// src/components/portfolio/PortfolioSelector.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown,  Settings } from 'lucide-react';
import { usePortfolio } from '../../contexts/PortfolioContext';

const PortfolioSelector = ({ compact = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { portfolios, selectedPortfolio, setSelectedPortfolio } = usePortfolio();
  const dropdownRef = React.useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []  );

  const handlePortfolioSelect = (portfolio) => {
    setSelectedPortfolio(portfolio);
    setIsOpen(false);
  };

  const renderButton = () => (
    <button
      onClick={() => setIsOpen(!isOpen)}
      className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-[#1f2544]"
    >
      <span className="flex items-center gap-1">
        <span>{selectedPortfolio?.icon || '💼'}</span>
        <span className="hidden md:inline text-sm text-gray-700 dark:text-gray-300">
          {selectedPortfolio?.name || 'Portföy Seç'}
        </span>
      </span>
      <ChevronDown size={16} className="text-gray-500" />
    </button>
  );

  return (
    <div className="relative" ref={dropdownRef}>
      {renderButton()}

      {isOpen && (
        <div className="absolute left-0 mt-2 w-48 bg-white dark:bg-[#151934] rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
          <div className="py-2">
            {portfolios.map((portfolio) => (
              <button
                key={portfolio.id}
                onClick={() => handlePortfolioSelect(portfolio)}
                className="flex items-center justify-between w-full px-3 py-2 text-left hover:bg-gray-100 dark:hover:bg-[#1f2544] text-gray-700 dark:text-gray-300"
              >
                <span className="flex items-center gap-2">
                  {portfolio.icon || '💼'}
                  <span className="truncate">{portfolio.name}</span>
                </span>
                {portfolio.id === selectedPortfolio?.id && (
                  <span className="ml-auto text-blue-500">✓</span>
                )}
              </button>
            ))}
          </div>
          
          <div className="border-t border-gray-200 dark:border-gray-700 py-2">
            <button
              onClick={() => navigate('/portfolio-management')}
              className="flex items-center w-full px-3 py-2 text-left hover:bg-gray-100 dark:hover:bg-[#1f2544] text-gray-700 dark:text-gray-300"
            >
              <Settings className="h-4 w-4 mr-2" />
              <span>Portföyleri Yönet</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioSelector;